import {mapMutations} from "vuex";
export default {
  name: "sizes-table",
  components:{
  },
  data(){
    return{

    }
  },
  created() {
  },
  computed:{

  },
  methods:{
    ...mapMutations({
    })
  }
}